import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactService } from 'src/app/services/contact.service';
import {
  DxButtonModule,
  DxDataGridComponent,
  DxDataGridModule,
  DxPopupModule,
  DxFileUploaderModule,
  DxLookupModule,
  DxTabPanelModule,
  DxToastModule,
  DxTextBoxModule,
  DxNumberBoxModule,
} from 'devextreme-angular';

import DataGrid from 'devextreme/ui/data_grid';
import { PropertyService } from 'src/app/services/property.service';
import { ActivatedRoute, Router } from '@angular/router';

import { ContactsPopupComponent } from 'src/app/components/contacts-popup/contacts-popup.component';
import { AppGlobals } from 'src/app/app.globals';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { DataAccessService } from 'src/app/services/data-access.service';
import { FileViewerComponent } from 'src/app/components/file-viewer/file-viewer.component';
import { DeletePopupComponent } from 'src/app/components/delete-popup/delete-popup.component';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { environment } from 'src/environments/environment';
import { ContractService } from 'src/app/services/contracts/contract.service';
import { GlobalPopupService } from 'src/app/components/generic-popup/presets/global-popup/global-popup.service';
import { FeatureFlags } from 'src/app/interfaces/enums/feature-flag';
import { ContractSelectorPopupComponent } from 'src/app/components/contract-selector-popup/contract-selector-popup.component';
import { Subject, takeUntil } from 'rxjs';
import { FileViewerService } from 'src/app/services/file-viewer.service';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { AppConfig } from 'src/app/app.config';
import { ContractsPillComponent } from 'src/app/components/contracts-pill/contracts-pill.component';
import { DocumentPillComponent } from 'src/app/components/document-pill/document-pill.component';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
import {
  FillTemplateGeneratedDoc,
  FillTemplateModalComponent,
  FillTemplateOwnerOption,
  fillTemplateFile,
} from 'src/app/components/fill-template-modal/fill-template-modal.component';

interface PropertyOwner {
  id: Number | undefined;
  gridConnectionId: Number | undefined;
  contactId?: number | undefined;
  contactType: string | undefined;
  name: string | undefined;
  contractFiles: Array<ContractFile> | undefined;
  properties: Array<Property> | undefined;
}

interface Property {
  propertyId?: number | undefined;
  sheet: string | undefined;
  district: string | undefined;
  hallway: string | undefined;
  parcel: string | undefined;
  size: string | undefined;
  localCourt: string | undefined;
  notes: string | undefined;
  registerFile: ContractFile;
}

interface ContractFile {
  contractId?: number | undefined;
  uuid?: string | undefined;
  filename: string | undefined;
  contractType: string | undefined;
  fileType: string | undefined;
  fileBytes: any | undefined;
  file: any | undefined;
}

@Component({
    selector: 'app-grid-connection-properties',
    templateUrl: './grid-connection-properties.component.html',
    styleUrls: ['./grid-connection-properties.component.css'],
    imports: [
        CommonModule,
        DxDataGridModule,
        NgxDocViewerModule,
        DxButtonModule,
        DxPopupModule,
        DxToastModule,
        DxFileUploaderModule,
        DxLookupModule,
        DeletePopupComponent,
        ContactsPopupComponent,
        DxTabPanelModule,
        DxPopupModule,
        DxTextBoxModule,
        DxNumberBoxModule,
        FileViewerComponent,
        ContractSelectorPopupComponent,
        GpdButtonComponent,
        ContractsPillComponent,
        DocumentPillComponent,
        FillTemplateModalComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [DeletePopupComponent]
})
export class GridConnectionPropertiesComponent implements OnInit {
  type: any = '';
  message: any = '';
  toastTwoVisible: boolean = false;

  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;
  @ViewChild('tabview') tabview: any;
  @ViewChild('masterGrid') masterGrid: DxDataGridComponent;

  searchTerm: string = '';

  @ViewChild(FileViewerComponent) fileViewer: FileViewerComponent;

  gridConnectionId: number;

  contractTypes = [
    { name: 'Dienstbarkeitsurkunde' },
    { name: 'Eintragungsbekanntmachung Dienstbarkeit' },
    { name: 'Gestattungsvertrag' },
    { name: 'Kaufvertrag' },
    { name: 'Nachtrag' },
    { name: 'Pachtvertrag' },
    { name: 'Übertragung' },
    { name: 'Unterpachtvertrag' },
  ];

  areaTypes = [{ name: 'PV Fläche' }, { name: 'Kabeltrasse' }, { name: 'sonstige' }];

  confirmText = $localize`:@@confirmCaps:CONFIRM`;
  cancelText = $localize`:@@cancelCaps:CANCEL`;

  propertyOwnerText: any = $localize`Do you want to remove this Poperty Owner and all properties from the list ? `;
  companies = new Array();
  persons = new Array();

  currentEditDetailGrid: DataGrid<any, any> | null;
  currentIndex: any;

  changedItems = new Array();

  propertyOwners = [];
  properties = [];

  propertyOwnersCheckClone = [];

  fileTmp: any;

  contactsEditMode: boolean = false;
  editMode: boolean = true;

  popupSelectedTab = 0;

  newId = 0;

  contactsPopupVisible: any;

  toastVisible: boolean = false;

  fileUrl: any;

  propertyStatus = 0;

  currentFile: any;

  selectedTabIndex = 0;

  contractTypesNew: any;
  contractAreaTypesNew: any;

  editorOptions: any;

  toDelete: any[];
  propertyContracts: any;

  contractsPopupVisible: boolean = false;
  contractPropertyOwnerTarget: any;
  currentPropertyOwner: any;

  addContactTitle = $localize`:@@addContact:Kontakt hinzufügen`;
  contactsPopupTitle: string = this.addContactTitle;
  replaceOwnerTarget: any = null;

  contractsEnabled: boolean = false;

  // Serienbrief (#148 follow-up): one filled document per selected land owner of this site.
  fillTemplateEnabled: boolean = false;
  fillTemplateVisible: boolean = false;
  private fillTemplateNeedsRefresh = false;
  fillTemplateOwners: FillTemplateOwnerOption[] = [];

  /**
   * Only an owner with a linked contact can be written to — without one there is no name, no
   * salutation and no address. Gating the button on this rather than on propertyOwners keeps a
   * site whose owners all lack a contact from opening a dialog with an empty recipient list.
   */
  get fillTemplateEligibleOwners(): number {
    return (this.propertyOwners ?? []).filter(o => o.id != null && o.contactId != null && o.contactType).length;
  }
  contractSelectorPopupVisible: boolean = false;

  currentExpandedKey: any;
  featureFlagsLoaded: boolean;
  selectedDocumentsByOwner = new Map<any, any[]>();
  private $unsubscribe = new Subject();

  constructor(
    private appGlobals: AppGlobals,
    private contactService: ContactService,
    private dataAccessService: DataAccessService,
    private router: Router,
    private propertyService: PropertyService,
    private activatedRoute: ActivatedRoute,
    private utilities: UtilitiesService,
    private contractService: ContractService,
    private fileViewerService: FileViewerService,
    private globalPopupService: GlobalPopupService,
    private activityLog: ActivityLogService
  ) {
    this.editorOptions = {
      maxLength: 13,
      max: 9999999999.999,
      min: 0,
      format: '#,##0.###',
      onKeyUp: this.onKeyUp.bind(this),
      validationRules: [
        {
          type: 'custom',
          validationCallback: e => this.validateNumber(e),
        },
      ],
    };

    this.save = this.save.bind(this);
  }

  ngOnInit(): void {
    this.appGlobals.$features.pipe(takeUntil(this.$unsubscribe)).subscribe(() => {
      this.contractsEnabled = AppGlobals.UserCan(FeatureFlags.Contracts);
      this.fillTemplateEnabled = AppGlobals.UserCan(FeatureFlags.AutomaticDocumentCreation);
      //this.featureFlagsLoaded = true;
    });

    if (environment.isTestEnvironment === true) {
      this.appGlobals.SetGlobalMenuIndex(1);
    } else {
      this.appGlobals.SetGlobalMenuIndex(1);
    }

    // React to the site id (re-load when navigating to a different site; paramsInheritanceStrategy
    // is 'always', so this also fires for the parent site/:id param while this component is reused).
    this.activatedRoute.paramMap.pipe(takeUntil(this.$unsubscribe)).subscribe(params => {
      const id = params.get('id');
      if (id != null && Number(id) !== this.gridConnectionId) {
        this.gridConnectionId = Number(id);
        this.activityLog.logView({ Section: ActivitySection.SITE_PROPERTY, SiteId: this.gridConnectionId });
        this.getPageData();
      }
    });

    // Focus a specific property when arriving from global search (?propertyId=).
    this.activatedRoute.queryParamMap.pipe(takeUntil(this.$unsubscribe)).subscribe(qp => {
      const pid = qp.get('propertyId');
      this.targetPropertyId = pid ? Number(pid) : null;
      this.focusTargetProperty();
    });
  }

  private targetPropertyId: number | null = null;

  // Expand the owner row that contains the targeted property (and scroll to it).
  private focusTargetProperty(): void {
    if (this.targetPropertyId == null || !this.propertyOwners?.length) return;
    const owner = this.propertyOwners.find(o => o.properties?.some(p => p.propertyId === this.targetPropertyId));
    if (!owner) return;
    this.currentExpandedKey = owner;
    setTimeout(() => {
      try {
        this.masterGrid?.instance?.expandRow(owner);
        this.masterGrid?.instance?.navigateToRow(owner);
      } catch {
        // grid not ready yet; the post-load hook will retry
      }
    }, 150);
  }

  getPageData() {
    let companiesPromise = this.contactService.getCompanies({});
    let personsPromise = this.contactService.getPersons({});
    let propertyOwnersPromise = this.propertyService.getPropertyOwners({
      PropertyOwnerItems: [{ GridConnectionId: Number(this.gridConnectionId) }],
    });

    let propertyStatusTaskPromise = this.propertyService.getPropertyTaskStatus({
      GridId: Number(this.gridConnectionId),
    });

    Promise.all([companiesPromise, personsPromise, propertyOwnersPromise, propertyStatusTaskPromise]).then(
      result => {
        if (result[0].hasError === true) AppGlobals.ShowErrorMessage(result[0].feedback);
        else {
          if (result[1].hasError === true) AppGlobals.ShowErrorMessage(result[1].feedback);
          else {
            if (result[2].hasError === true) AppGlobals.ShowErrorMessage(result[2].feedback);
            else {
              if (result[3].hasError === true) AppGlobals.ShowErrorMessage(result[3].feedback);
              else {
                this.companies = result[0].companyItems;
                this.persons = result[1].personItems;
                this.propertyOwners = result[2].propertyOwnerItems;
                this.propertyOwnersCheckClone = result[2].propertyOwnerItems;
                this.propertyStatus = result[3].statusId;

                // Focus the property requested via ?propertyId= (e.g. from global search).
                this.focusTargetProperty();

                if (this.currentExpandedKey != null) {
                  const expandedId = this.currentExpandedKey?.id;
                  const savedTabIndex = this.selectedTabIndex;
                  setTimeout(() => {
                    const newKey = this.propertyOwners.find(o => o.id === expandedId);
                    if (newKey) {
                      this.selectedTabIndex = savedTabIndex;
                      this.masterGrid?.instance?.expandRow(newKey);
                    }
                  }, 100);
                }
              }
            }
          }
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    this.dataAccessService.getContractTypes({}).then(
      result => {
        this.contractTypesNew = result.contractTypeItems;
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    this.dataAccessService.getContractAreaTypes({}).then(
      result => {
        this.contractAreaTypesNew = result.contractAreaTypeItems;
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  selectionChanged(e) {
    e.component.collapseAll(-1);
    e.component.expandRow(e.currentSelectedRowKeys[0]);
  }

  onDocumentSelectionChanged(e: any, owner: any): void {
    this.selectedDocumentsByOwner.set(owner.id, e.selectedRowsData);
  }

  hasSelectedDocuments(owner: any): boolean {
    return (this.selectedDocumentsByOwner.get(owner.id) ?? []).length > 0;
  }

  moveDocumentsToContracts(owner: any): void {
    const docs = this.selectedDocumentsByOwner.get(owner.id) ?? [];
    if (!docs.length) return;
    this.contractService.setPreviousUrl(this.router.url);
    this.router.navigate(['/contracts/addToPropertyOwner', owner.id], {
      state: {
        propertyOwnerDocuments: docs,
        propertyOwnerContext: owner,
        gridConnectionId: this.gridConnectionId,
      },
    });
  }

  onContactSelected(e) {
    let name = this.buildContactName(e.data, e.type);

    if (this.replaceOwnerTarget != null) {
      this.replaceOwner(e.data, e.type, name);
      return;
    }

    const propertyOwner: PropertyOwner = {
      id: this.getNewId(),
      gridConnectionId: this.gridConnectionId,
      contactId: e.data.id,
      contactType: e.type,
      name: name, //e.type === 'company' ? e.data.name : `${e.data.firstname} ${e.data.lastname} `,
      contractFiles: [],
      properties: [],
    };

    this.propertyOwners.push(propertyOwner);
    this.contactsPopupVisible = false;
    this.save();
    //this.dataGrid.instance.refresh();
  }

  onContactAdded(e) {
    const addNewPropertyOwner = (contactType, name) => {
      this.contactService[contactType === 'company' ? 'getCompanies' : 'getPersons']({}).then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            let items = contactType === 'company' ? this.companies : this.persons;
            items = result[contactType === 'company' ? 'companyItems' : 'personItems'];

            const newItem = items.find(item => item.id === e.id);

            if (this.replaceOwnerTarget != null) {
              const name = this.buildContactName(newItem, contactType);
              this.replaceOwner(newItem, contactType, name);
              this.contactsPopupVisible = false;
              return;
            }

            const newPropertyOwner: PropertyOwner = {
              id: this.getNewId(),
              gridConnectionId: this.gridConnectionId,
              contactId: e.id,
              contactType: e.type,
              name: contactType == 'company' ? newItem.name : `${newItem.firstname} ${newItem.lastname} `,
              contractFiles: [],
              properties: [],
            };

            this.propertyOwners.push(newPropertyOwner);
            this.save();
            this.contactsPopupVisible = false;
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    };

    if (e.type === 'company') {
      addNewPropertyOwner('company', e.name);
    }

    if (e.type === 'person') {
      addNewPropertyOwner('person', `${e.firstname} ${e.lastname} `);
    }
  }

  buildContactName(data: any, type: string): string {
    if (type === 'company') return data?.name != null ? data.name : '--';
    if (type === 'society') return data?.displayName || '--';
    let name = '';
    if (data?.firstname != null) name = data.firstname;
    if (data?.lastname != null) name += ' ' + data.lastname;
    return name.trim() === '' ? '--' : name;
  }

  showReplaceOwnerPopup(owner: any) {
    this.replaceOwnerTarget = owner;
    this.contactsPopupTitle = $localize`:@@changePropertyOwnerTitle:Change property owner`;
    this.contactsPopupVisible = true;
  }

  resetContactsPopup() {
    this.replaceOwnerTarget = null;
    this.contactsPopupTitle = this.addContactTitle;
  }

  replaceOwner(contactData: any, type: string, name: string) {
    const target = this.replaceOwnerTarget;
    target.contactId = contactData.id;
    target.contactType = type;
    target.name = name;

    this.propertyService.savePropertyOwners({ PropertyOwnerItems: [target] }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.contactsPopupVisible = false;
          this.resetContactsPopup();
          this.showOwnerChangedWarning();
          this.getPageData();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  showOwnerChangedWarning() {
    this.globalPopupService.showPopup({
      title: $localize`:@@changePropertyOwnerTitle:Change property owner`,
      titleIcon: 'alert',
      content: $localize`:@@ownerChangedWarning:Please note that when changing the property owner, the details of the contracting party in existing contracts under 'Contracts' must also be adjusted accordingly.`,
      buttons: [
        {
          text: $localize`:@@understood:Understood`,
          type: 'primary',
          onClick: () => {},
        },
      ],
    });
  }

  async save() {
    for (let propertyOwner of this.propertyOwners) {
      for (let property of propertyOwner.properties) {
        if (property.registerFile?.fileBytes != null || property.registerFile?.fileBytes != undefined) {
          let result = await this.uploadRegisterFile(propertyOwner, property);
          if (result != null) {
            property.registerFile.uuid = result.propertyContractResultItem.uuid;
            property.registerFile.uploadDate = result.propertyContractResultItem.uploadDate;
            property.registerFile.uploadedBy = result.propertyContractResultItem.uploadedBy;
          } else {
            return;
          }
        }
      }

      for (let contract of propertyOwner.contractFiles) {
        if (contract.fileBytes != null || contract.fileBytes != undefined) {
          let result = await this.uploadContractFile(propertyOwner, contract);
          if (result != null) {
            contract.uuid = result.propertyContractResultItem.uuid;
            contract.uploadDate = result.propertyContractResultItem.uploadDate;
            contract.uploadedBy = result.propertyContractResultItem.uploadedBy;
          } else {
            return;
          }
        }
      }
    }
    console.log(this.propertyOwners);

    this.propertyService.savePropertyOwners({ PropertyOwnerItems: this.propertyOwners }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
          this.toastVisible = true;
          this.editMode = true;
          this.getPageData();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  uploadRegisterFile(propertyOwner: any, property: any) {
    var formData = new FormData();
    formData.append('gridConnectionId', this.gridConnectionId.toString());
    formData.append('propertyId', property.propertyId.toString());
    formData.append('contractType', property.registerFile.contractType);
    formData.append('contactId', propertyOwner.contactId.toString());
    formData.append('contactType', propertyOwner.contactType);
    formData.append('filename', property.registerFile.filename);
    formData.append('fileType', property.registerFile.fileType);
    formData.append('fileBytes', property.registerFile.fileBytes);
    formData.append('notes', property.notes);

    return this.propertyService.uploadContractFileToSharepoint(formData).then(
      result => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
          return null; // or any other value you want to return in case of error
        } else {
          return result;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    if ((this.type = 'success')) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage($localize`:@@errorTryAgain:ERROR: There was an error, please try again.`);
    }
  }

  uploadContractFile(propertyOwner, contract: any) {
    var formData = new FormData();
    formData.append('gridConnectionId', this.gridConnectionId.toString());
    formData.append('contractType', contract.contractType);
    formData.append('contractTypeId', contract.contractTypeId);
    formData.append('contactId', propertyOwner.contactId.toString());
    formData.append('contactType', propertyOwner.contactType);
    formData.append('filename', contract.filename);
    formData.append('fileType', contract.fileType);
    formData.append('fileBytes', contract.fileBytes);
    formData.append('notes', contract.notes);

    return this.propertyService.uploadContractFileToSharepoint(formData).then(result => {
      if (result.hasError === true) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return null; // or any other value you want to return in case of error
      } else {
        return result;
      }
    });
  }

  /**
   * Snapshotted when the dialog opens rather than bound through a getter: a getter would hand the
   * modal a fresh array on every change detection cycle, and owners cannot change while it is open.
   */
  openFillTemplate(): void {
    this.fillTemplateOwners = (this.propertyOwners ?? [])
      .filter(o => o.id != null && o.contactId != null && o.contactType)
      .map(o => ({ id: o.id, name: o.name }));
    this.fillTemplateVisible = true;
  }

  /**
   * Files one generated letter under its land owner. The owner's "Dokumente" grid is the contract
   * list, so this is the same upload the manual "Add document" row performs — hence the document
   * type, which the server turns into the SharePoint filename.
   */
  fillTemplateAddToOwner = async (doc: FillTemplateGeneratedDoc): Promise<boolean> => {
    const owner = this.propertyOwners.find(o => o.id === doc.targetId);
    if (owner?.id == null || owner.contactId == null || !owner.contactType || doc.documentTypeId == null) return false;

    const file = fillTemplateFile(doc);
    const formData = new FormData();
    formData.append('gridConnectionId', this.gridConnectionId.toString());
    // The owner id is what makes the server create the PropertyContract row the document grid
    // reads; without it the file reaches SharePoint and is never listed anywhere.
    formData.append('propertyOwnerId', owner.id.toString());
    formData.append('contractTypeId', doc.documentTypeId.toString());
    formData.append('contactId', owner.contactId.toString());
    formData.append('contactType', owner.contactType);
    formData.append('filename', file.name);
    formData.append('fileType', file.type);
    formData.append('fileBytes', file);

    // No global blocking spinner here: the fill-template dialog shows its own per-row progress
    // ("Wird hinzugefügt…" on the active row, counter on "Alle hinzufügen"), and the overlay would
    // only cover it — one letter at a time, or the whole "add all" run.
    const result = await this.propertyService.uploadContractFileToSharepoint(formData, false);
    if (result?.hasError === true) {
      AppGlobals.ShowErrorMessage(result.feedback);
      return false;
    }
    // Deliberately no reload here: "Alle hinzufügen" calls this once per letter, and getPageData
    // would reassign propertyOwners and contractTypesNew under the running loop — the next owner
    // lookup could miss and the letter be counted as failed. The grid refreshes once on close.
    this.fillTemplateNeedsRefresh = true;
    return true;
  };

  /** One refresh for the whole run, after the dialog is done with the grid's data. */
  onFillTemplateClosed(): void {
    if (!this.fillTemplateNeedsRefresh) return;
    this.fillTemplateNeedsRefresh = false;
    this.getPageData();
  }

  handleAbortCompany(e) {
    this.contactsEditMode = false;
  }

  handleAbortPerson(e) {
    this.contactsEditMode = false;
  }

  getElementName(propertyOwner) {
    return `${propertyOwner.data.type}_${propertyOwner.data.id} `;
  }

  addRow(target) {
    if (this.currentEditDetailGrid != undefined) {
      this.currentEditDetailGrid.cancelEditData();
    }
    let element = document.getElementById(target);
    let instance = DataGrid.getInstance(element) as DataGrid;
    this.currentEditDetailGrid = instance;
    instance.addRow(/* {size:null} */);
  }

  getNewId() {
    return (this.newId -= 1);
  }

  onEditCanceling() {
    this.fileTmp = null;
    this.currentEditDetailGrid = null;

    this.getPageData();
  }

  fileChanged(e, property) {
    const file = e.target.files[0];
    if (file.name.length > AppConfig.MaxFileNameLength) {
      AppGlobals.ShowErrorMessage(
        $localize`:@@fileNameTooLongError:File name is too long. Maximum allowed length is ${AppConfig.MaxFileNameLength}:maxLength: characters.`
      );
      e.target.value = '';
      return;
    }
    this.fileTmp = file;
  }

  editRow(target, propertyId) {
    if (this.currentEditDetailGrid) {
      this.currentEditDetailGrid.cancelEditData();
    }

    const instance = DataGrid.getInstance(document.getElementById(target)) as DataGrid;
    this.currentEditDetailGrid = instance;

    const index = instance.getVisibleRows().findIndex(item => item.data.propertyId === propertyId);
    this.currentIndex = index;
    instance.editRow(index);
  }

  validationCallback(e) {
    return this.fileTmp == null ? true : false;
  }

  showContract(e, data) {
    if (e.columnIndex == 8) {
      let payload = {
        gridConnectionId: data.gridConnectionId,
        contractId: e.row.data.contractFile.contractId,
      };

      this.propertyService.getContractFromSharepoint({ ContractRequestItem: payload }).then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            let bytes = this.base64ToArrayBuffer(result.contractResultItem.fileBytes);
            this.saveByteArray('file', result.contractResultItem.fileType, bytes);
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    }
  }

  toggleEditMode(arg) {
    this.editMode = arg;
  }

  abortChanges() {
    this.toggleEditMode(true);
    this.getPageData();
  }

  currentEdit: any;

  onPropertyRowInserted(e) {
    e.data['propertyId'] = this.getNewId();
    if (this.fileTmp != null) {
      e.data['registerFile'] = {
        contractId: this.getNewId(),
        filename: this.fileTmp.name,
        contractType: 'registerFile',
        fileType: this.fileTmp.type,
        fileBytes: this.fileTmp,
        file: null,
      };
    }
    this.fileTmp = null;
    this.currentEditDetailGrid = null;
    this.currentEdit = null;
  }

  onPropertyRowUpdated(e) {
    if (this.currentEdit != null || this.currentEdit != undefined) {
      if (this.fileTmp != null) {
        this.currentEdit['registerFile'] = {
          contractId: this.getNewId(),
          filename: this.fileTmp.name,
          contractType: 'registerFile',
          fileType: this.fileTmp.type,
          fileBytes: this.fileTmp,
          file: null,
        };
      }
      this.fileTmp = null;
      this.currentEditDetailGrid = null;
      this.currentEdit = null;
    }
    if (this.registerFileToDelete != null) {
      this.deleteRegisterFile().then(
        result => {
          this.save();
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    } else {
      this.save();
    }
  }

  onEditingStart(e) {
    this.currentEdit = e.data;
  }

  // sizeCaption: string = 'Größe';
  onEditorPrepared(e: any) {
    // Only attach handler if editing the area type field in the form
    // if (e.dataField === "areaTypeId" && e.parentType === "dataRow") {
    //   const originalHandler = e.editorOptions.onValueChanged;
    //   e.editorOptions.onValueChanged = (ev: any) => {
    //     const selected = this.contractAreaTypesNew.find(x => x.id === ev.value);
    //     if (selected?.name.toLowerCase() === "kabeltrasse") {
    //       this.sizeCaption = $localize`:@@sizeInM:size m`;
    //     } else {
    //       this.sizeCaption = $localize`:@@sizeInM^2:size m²`;
    //     }
    //     // Refresh captions immediately
    //     e.component.refresh();
    //     // Keep DevExtreme's own handler if it exists
    //     if (originalHandler) originalHandler(ev);
    //   };
    // }
  }

  sizeCaption: string = $localize`:@@sizeInM^2:size m²`;

  onContractRowInserting(e) {
    if (!this.fileTmp) {
      e.cancel = true;
      AppGlobals.ShowErrorMessage($localize`:@@fileRequiredError:Please select a file before saving.`);
    }
  }

  onContractRowInserted(e) {
    e.data['contractId'] = this.getNewId();
    e.data['filename'] = this.fileTmp.name;
    e.data['fileType'] = this.fileTmp.type;
    e.data['fileBytes'] = this.fileTmp;

    this.fileTmp = null;
    this.currentEditDetailGrid = null;
    this.currentEdit = null;

    console.log('Contract row inserted:', this.propertyOwners);
  }

  /*************** stuff for deleting something *********************/

  deletePopupVisible = false;
  deleteMessage = '';

  deleteOwnerVisible = false;
  deletePropertyVisible = false;
  deleteFileVisible = false;

  ownerToDelete: any;
  propertyToDelete: any;
  registerFileToDelete: any;
  contractToDelete: any;

  fileToDeleteName: any = null;

  fileToDelete: any;

  initDeletionPropertyOwner(propertyOwner, message) {
    this.deletePopupVisible = true;
    const name = propertyOwner.name ? `<strong>${propertyOwner.name}</strong>` : $localize`:@@thisOwner:this owner`;
    if (propertyOwner.properties.length <= 0) {
      this.deleteMessage = $localize`:@@deleteOwnerNoProperties:Do you want to remove ${name}:name: and all associated properties?`;
    } else {
      this.deleteMessage = $localize`:@@deleteOwnerWithProperties:Do you want to remove ${name}:name: and all associated properties from the list?`;
    }
    this.ownerToDelete = propertyOwner;
  }

  initDeletionProperty(propertyOwner, property) {
    this.deletePopupVisible = true;
    const ref = property.parcel ?? property.sheet ?? null;
    const name = ref ? `<strong>${ref}</strong>` : $localize`:@@thisProperty:this property`;
    this.deleteMessage = $localize`:@@propWantToRemove:Do you want to remove ${name}:name:?`;
    this.propertyToDelete = {
      propertyOwner: propertyOwner,
      property: property,
    };
  }

  initDeleteFile(e, propertyOwner, contractType, index) {
    this.deletePopupVisible = true;
    let p = this.propertyOwners.find(item => item == propertyOwner.data);
    this.fileToDelete = {
      owner: propertyOwner,
      file: index.registerFile,
    };
    const name = index.registerFile ? `<strong>${index.registerFile}</strong>` : $localize`:@@thisFile:this file`;
    this.deleteMessage = $localize`:@@propWantToDelete:Do you want to delete ${name}:name:?`;
    this.fileToDeleteName = index.registerFile;
  }

  initDeleteRegisterFile(propertyOwner, property) {
    this.registerFileToDelete = {
      propertyOwner: propertyOwner,
      property: structuredClone(property),
      deleteFun: () => {
        property.registerFile = null;
      },
    };
    const name = property.registerFile?.filename
      ? `<strong>${property.registerFile.filename}</strong>`
      : $localize`:@@thisRegisterFile:this register file`;
    this.deleteMessage = $localize`:@@propConfirmDelete:Are you sure you want to delete ${name}:name:?`;
    this.deletePopupVisible = true;
  }

  initDeleteDocument(propertyOwner, document) {
    this.contractToDelete = {
      propertyOwner: propertyOwner,
      contract: document,
    };
    const name = (document.contractType ?? document.filename)
      ? `<strong>${document.contractType ?? document.filename}</strong>`
      : $localize`:@@thisDocument:this document`;
    this.deleteMessage = $localize`:@@propConfirmDelete:Are you sure you want to delete ${name}:name:?`;
    this.deletePopupVisible = true;
  }

  initDeleteContract(propertyOwner, contract) {
    this.contractToDelete = {
      propertyOwner: propertyOwner,
      contract: contract,
    };
    const name = (contract.contractType ?? contract.filename)
      ? `<strong>${contract.contractType ?? contract.filename}</strong>`
      : $localize`:@@thisContract:this contract`;
    this.deleteMessage = $localize`:@@propConfirmDelete:Are you sure you want to delete ${name}:name:?`;
    this.deletePopupVisible = true;
  }

  handleAbort(e) {
    this.deletePopupVisible = false;
  }

  handleSubmit(e) {
    this.deletePopupVisible = false;

    if (this.ownerToDelete != null) {
      this.deleteOwner();
      this.ownerToDelete = null;
    }

    if (this.propertyToDelete != null) {
      this.deleteProperty();
      this.propertyToDelete = null;
    }
    if (this.registerFileToDelete != null) {
      this.registerFileToDelete.deleteFun();
    }

    if (this.contractToDelete != null) {
      this.deleteContract();
      this.contractToDelete = null;
    }
  }

  deleteContract() {
    if (this.contractToDelete.contract.contractId < 0) {
      let indexPo = this.propertyOwners.findIndex(item => item.id == this.contractToDelete.propertyOwner.id);
      let indexP = this.propertyOwners[indexPo].contractFiles.findIndex(
        item => item.contractId == this.contractToDelete.contract.contractId
      );
      if (indexP != -1) {
        this.propertyOwners[indexPo].contractFiles.splice(indexP, 1);
      }
    } else {
      let payload = {
        ...this.contractToDelete.propertyOwner,
        contractFiles: [this.contractToDelete.contract],
      };

      this.propertyService.deletePropertyContract({ PropertyOwnerItems: [payload] }).then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.getPageData();
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    }
  }

  deleteOwner() {
    if (this.ownerToDelete.id < 0) {
      let index = this.propertyOwners.findIndex(item => item.id == this.ownerToDelete.id);
      if (index != -1) {
        this.propertyOwners.splice(index, 1);
      }
    } else {
      this.propertyService.deletePropertyOwner({ PropertyOwnerItems: [this.ownerToDelete] }).then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.getPageData();
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    }
  }

  deleteProperty() {
    if (this.propertyToDelete.property.propertyId < 0) {
      let indexPo = this.propertyOwners.findIndex(item => item.id == this.propertyToDelete.propertyOwner.id);
      let indexP = this.propertyOwners[indexPo].properties.findIndex(
        item => item.propertyId == this.propertyToDelete.property.propertyId
      );
      if (indexP != -1) {
        this.propertyOwners[indexPo].properties.splice(indexP, 1);
      }
    } else {
      let payload = {
        ...this.propertyToDelete.propertyOwner,
        properties: [this.propertyToDelete.property],
      };

      (this.propertyService.deleteProperty({ PropertyOwnerItems: [payload] }).then(result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.getPageData();
        }
      }),
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        });
    }
  }

  async deleteRegisterFile() {
    if (this.registerFileToDelete.property.propertyId < 0) {
      let indexPo = this.propertyOwners.findIndex(item => item.id == this.registerFileToDelete.propertyOwner.id);
      let indexP = this.propertyOwners[indexPo].properties.findIndex(
        item => item.propertyId == this.registerFileToDelete.property.propertyId
      );
      if (indexP != -1) {
        this.propertyOwners[indexPo].properties[indexP].registerFile = {
          contractId: null,
          filename: null,
          contractType: null,
          fileType: null,
          fileBytes: null,
          file: null,
        };
      }
    } else {
      let payload = {
        ...this.registerFileToDelete.propertyOwner,
        properties: [this.registerFileToDelete.property],
      };

      const result = await this.propertyService.deleteRegisterFile({
        PropertyOwnerItems: [payload],
      });
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else this.registerFileToDelete = null;
    }
  }

  getDocument(e, owner, contractType) {
    let contractId = owner.contractFiles[contractType].contractId;
    this.propertyService
      .getDocument({ contractId: contractId })
      .then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            let bytes = this.base64ToArrayBuffer(result.fileResultItem.fileBytes);
            this.saveByteArray('file', result.fileResultItem.fileType, bytes);
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      )
      .catch(error => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  getRegisterFileFromSharepoint(e, owner, property) {
    if (property.registerFile == null) return;
    if (property.registerFile.uuid == null) return;
    if (property.registerFile.uuid == '') return;
    if (this.fileViewer == null) return;

    this.fileViewerService.openOrDownloadFile(
      'property-file',
      property.registerFile.uuid,
      property.registerFile.filename,
      null
    );

    return;
    let payload = {
      gridConnectionId: owner.gridConnectionId,
      propertyId: property.propertyId,
    };

    this.propertyService.getRegisterFileFromSharepoint({ RegisterFileRequestItem: payload }).then(result => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        let bytes = this.base64ToArrayBuffer(result.fileResultItem.fileBytes);
        this.saveByteArray('file', result.fileResultItem.fileType, bytes);
      }
    });
  }

  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  saveByteArray(reportName, fileType, byte) {
    let mimeType = '';

    switch (fileType) {
      case 'png':
      case 'jpeg':
        mimeType = `image/${fileType}`;
        break;
      case 'csv':
      case 'txt':
        mimeType = `text/${fileType}`;
        break;
      case 'pdf':
      case 'json':
      case 'zip':
        mimeType = `application/${fileType}`;
        break;
      case 'xls':
        mimeType = `application/vnd.ms-excel`;
        break;
      case 'ppt':
        mimeType = `application/vnd.ms-powerpoint`;
        break;
      case 'odt':
        mimeType = `application/vnd.oasis.opendocument.text`;
        break;
      case 'pptx':
        mimeType = `application/vnd.openxmlformats-officedocument.presentationml.presentation`;
        break;
      case 'xlsx':
        mimeType = `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`;
        break;
      case 'docx':
        mimeType = `application/vnd.openxmlformats-officedocument.wordprocessingml.document`;
        break;
    }

    var blob = new Blob([byte], { type: mimeType });
    let link = window.URL.createObjectURL(blob);

    window.open(link);
  }

  setPropertyTaskStatus(e) {
    this.propertyStatus = e;
    this.propertyService
      .setPropertyTaskStatus({
        GridId: this.gridConnectionId,
        StatusId: this.propertyStatus,
      })
      .then(
        result => {
          this.getPageData();
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
  }

  closePopup(): any {
    this.deletePopupVisible = false;
  }

  onMasterRowExpanding(e) {
    this.currentExpandedKey = e.key;
    this.masterGrid.instance.collapseAll(-1);
  }

  reFormatNumber(event: any): any {
    let cellValue = event.component._parsedValue;
    let cellParsedValue = parseInt(cellValue);
    event.component._parsedValue = new Intl.NumberFormat('de-DE').format(cellParsedValue);
    return new Intl.NumberFormat('de-DE').format(cellParsedValue);
  }

  validateNumber(e) {
    const value = e.value;
    const regex = /^\d{0,10}(\.\d{0,3})?$/;
    return regex.test(value);
  }

  formatValidNumber(input) {
    const parts = input.split('.');
    if (parts[0].length > 10) {
      parts[0] = parts[0].substring(0, 10);
    }
    if (parts[1] && parts[1].length > 3) {
      parts[1] = parts[1].substring(0, 3);
    }
    return parts.join('.');
  }

  onKeyUp(event) {
    const input = event.component.option('value');
    if (!this.validateNumber({ value: input })) {
      event.component.option('value', this.reFormatNumber({ component: { _parsedValue: input } }));
    }
  }

  jumpToContactDetails(arg0: any, arg1: any) {
    this.router.navigate([`contacts/${arg0}/${arg1}`]);
  }

  // sizeCaption: string = $localize`:@@sizeInM^2:size m²`;
  numberValue: string = '';
  setNumberValue(event: any): void {
    let input = event.toString();
    if (this.isValidInput(input)) {
      this.numberValue = this.formatToGermanNumber(input);
    }
  }

  handleInput(event: any, index: any): void {
    const input = event.event.target.value;
    const sanitizedInput = this.sanitizeInput(input);
    if (this.isValidInput(sanitizedInput)) {
      this.numberValue = this.formatToGermanNumber(sanitizedInput);
    } else {
      event.event.target.value = this.numberValue;
    }
  }

  handleKeyDown(event: any): void {
    const charCode = event.event.which ? event.event.which : event.event.keyCode;
    const charStr = String.fromCharCode(charCode);
    // Allow control keys (backspace, delete, arrow keys, etc.)
    if (charCode === 8 || charCode === 46 || (charCode >= 37 && charCode <= 40)) {
      return;
    }

    // Allow only numbers, comma, and period
    if (!charStr.match(/^[0-9]$/)) {
      if (charCode == 188 || charCode == 190) return;
      else {
        event.event.preventDefault();
      }
    } else {
    }
  }

  sanitizeInput(input: string): string {
    return input.replace(/[^0-9.,]/g, '');
  }

  isValidInput(value: string): boolean {
    const parts = value.split(',');

    // Check if there are more than one comma
    if (parts.length > 2) {
      return false;
    }

    const integerPart = parts[0].replace(/\./g, '');
    const decimalPart = parts[1] || '';

    return integerPart.length <= 10 && decimalPart.length <= 3;
  }

  formatToGermanNumber(value: string): string {
    const parts = value.split(',');
    let integerPart = parts[0].replace(/\./g, '');
    const decimalPart = parts[1] || '';

    // Add thousands separator
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return decimalPart ? `${integerPart},${decimalPart}` : integerPart;
  }

  returnToParesedValue(value: string): any {
    const parts = value.split(',');

    // Check if there are more than one comma
    if (parts.length > 2) {
      return parts.length[0] + parts.length[1];
    }

    const integerPart = parts[0].replace(/\./g, '');
    const decimalPart = parts[1] || '';
    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
  }

  async sizeDigitsLimited(e: any, dataSource) {
    let parsedNumber = parseFloat(this.returnToParesedValue(e));
    dataSource.data.size = parsedNumber;
    for (let i = 0; i < this.propertyOwners.length; i++) {
      if (dataSource.data.propertyOwnerId === this.propertyOwners[i].id) {
        let properties = this.propertyOwners[i].properties;
        for (let u = 0; u < properties.length; u++) {
          if (dataSource.data.propertyId === properties[u].propertyId) {
            properties[u].size = parsedNumber;
          }
        }
      }
    }
  }

  parseGermanNumber(value: string): number {
    const withoutThousandSeparators = value.replace(/\./g, '');
    const withDecimalDot = withoutThousandSeparators.replace(',', '.');
    return parseFloat(withDecimalDot);
  }

  customizeText = (cellInfo: any) => {
    return this.customNumberFormat(cellInfo.value);
  };

  customNumberFormat(value: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    const numberValue = this.parseGermanNumber(value);
    const parts = numberValue.toFixed(2).split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const decimalPart = parts[1];
    return `${integerPart},${decimalPart}`;
  }

  formatNumberConvetions(value: number): string {
    if (isNaN(value)) {
      return '';
    }
    //return value + ' €';
    return value.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  enforceMaxLength(e: any) {
    const input = e.event.target;
    const [whole, decimal] = input.value.split(',');
    // Enforce 8 digits before the decimal point
    if (whole.length > 10) {
      input.value = whole.slice(0, 10) + (decimal ? `,${decimal}` : '');
    }
  }

  saveContract(e: any): void {
    this.currentEditDetailGrid = null;
    this.save();
  }

  onContractSelected(e: any) {
    // check if contract is allready in the list

    if (this.contractPropertyOwnerTarget.findIndex(c => c.id == e.id) != -1) {
      this.globalPopupService.showWarningPopup(
        $localize`:@@contractAlreadyAdded:This contract was already added!`
      );
    } else {
      this.contractSelectorPopupVisible = false;
      const payload = { ContractId: e.id, PropertyOwnerId: this.currentPropertyOwner.id };
      this.propertyService.addContractToPropertyOwner(payload).then(result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.toastVisible = true;
          this.getPageData();
        }
      });
    }
  }

  showContractSelectionPopup(target) {
    this.contractSelectorPopupVisible = true;
    this.currentPropertyOwner = target;
    this.contractPropertyOwnerTarget = target.contracts;
  }

  removeContract(propertyOwner: any, contract) {
    const designation = contract.designation ?? '';
    const localized = $localize`:@@removeContractConfirm:Are you sure you want to remove "${designation}:DESIGNATION:"?`;
    const boldContent = localized.split(designation).join(`<strong>${designation}</strong>`);

    this.globalPopupService.showPopup({
      title: $localize`:@@confirmChanges:Confirm changes`,
      content: boldContent,
      buttons: [
        {
          text: $localize`:@@cancel:Cancel`,
          type: 'tertiary-text',
          onClick: () => {},
        },
        {
          text: $localize`:@@yesRemove:Yes, remove`,
          type: 'danger',
          onClick: () => {
            const index = propertyOwner.contracts.findIndex(c => c.id === contract.id);
            if (index !== -1) propertyOwner.contracts.splice(index, 1);

            const payload = {
              ContractId: contract.id,
              PropertyOwnerId: propertyOwner.id,
            };

            this.propertyService.removeContractFromPropertyOwner(payload).then(result => {
              if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
              else {
                this.toastVisible = true;
                this.getPageData();
              }
            });
          },
        },
      ],
    });
  }

  downloadAllContractsForPropertyOwner(propertyOwner: any): void {
    const contractIds = (propertyOwner.contracts || []).map(c => c.id);
    if (!contractIds.length) return;

    this.contractService.downloadContractDocuments({ contractIds, zipFileName: propertyOwner.name });
  }
}
